import React from 'react';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <p className="copyright">Дзæуджыхъæу © {new Date().getFullYear()} Ironvector</p>
        <div className="footer-links">
          <Link to="/policy">Политика</Link>
          <Link to="/terms">Соглашение</Link>
          <Link to="/company">Компания</Link>
        </div>
      </div>
    </footer>
  );
}
export default Footer;